import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button
} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import ToolkitProvider, {
  Search,
  CSVExport
} from "react-bootstrap-table2-toolkit";

import filterFactory from "react-bootstrap-table2-filter";

import {
  getLiveTransporters,
  deleteLiveTransporter
} from "../../services/api/api-service";


const LiveVehiclesLists = () => {

  const [list, setList] = useState([]);


  useEffect(() => {
    fetchData();
  }, []);


  const fetchData = async () => {
    try {

      const response = await getLiveTransporters();

      console.log("API RESPONSE =====>", response);

      setList(response || []);

    } catch (error) {

      console.log("API ERROR", error);

    }
  };


  const handleDelete = async (id) => {

    const confirm = window.confirm(
      "Are you sure you want to delete this live vehicle?"
    );

    if (!confirm) {
      return;
    }

    try {

      await deleteLiveTransporter(id);

      setList(prevList =>
        prevList.filter(item => item.id !== id)
      );

      alert("Live vehicle deleted successfully");

    } catch (error) {

      console.log("DELETE ERROR", error);

      alert("Unable to delete vehicle");

    }

  };


  const columns = [

    {
      dataField: "contactName",
      text: "Name",
      sort: true
    },

    {
      dataField: "contactNumber",
      text: "Contact",
      sort: true
    },

    {
      dataField: "businessName",
      text: "Business",
      sort: true
    },

    {
      dataField: "currentLocation",
      text: "Current Location",
      sort: true
    },

    {
      dataField: "destinationLocation",
      text: "Destination Location",
      sort: true
    },

    {
      dataField: "createdAt",
      text: "Date",
      formatter: (cell) =>
        cell ? new Date(cell).toLocaleString() : "-"
    },

    {
      dataField: "isActive",
      text: "Status",
      formatter: (cell) =>
        cell ? "Active" : "Expired"
    },

    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <Button
          color="danger"
          size="sm"
          onClick={() => handleDelete(row.id)}
        >
          Delete
        </Button>
      )
    }

  ];


  const options = {

    sizePerPage: 10,
    sizePerPageList: [
      {
        text: "10",
        value: 10
      },
      {
        text: "20",
        value: 20
      },
      {
        text: "50",
        value: 50
      }
    ]

  };


  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;


  return (

    <div className="page-content">

      <Container fluid>

        <Breadcrumbs
          title="Admin"
          breadcrumbItem="Live Vehicles"
        />

        <Row>

          <Col lg="12">

            <Card>

              <CardBody>

                <CardTitle className="h4">
                  Live Vehicles
                </CardTitle>


                <ToolkitProvider
                  keyField="id"
                  data={list}
                  columns={columns}
                  search
                  exportCSV
                >

                {
                  props => (

                    <>

                      <Row className="mb-3">

                        <Col md="4">

                          <SearchBar
                            {...props.searchProps}
                          />

                        </Col>


                        <Col md="8" className="text-end">

                          <ExportCSVButton
                            {...props.csvProps}
                            className="btn btn-success"
                          >
                            Download CSV
                          </ExportCSVButton>

                        </Col>

                      </Row>


                      <BootstrapTable
                        {...props.baseProps}
                        pagination={paginationFactory(options)}
                        filter={filterFactory()}
                        classes="table table-bordered"
                      />

                    </>

                  )
                }

                </ToolkitProvider>


              </CardBody>

            </Card>

          </Col>

        </Row>

      </Container>

    </div>

  );

};


export default LiveVehiclesLists;